import { render, staticRenderFns } from "./DiscountAdvantagesPopin.vue?vue&type=template&id=6c24134d&scoped=true&"
import script from "./DiscountAdvantagesPopin.vue?vue&type=script&lang=js&"
export * from "./DiscountAdvantagesPopin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24134d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c24134d')) {
      api.createRecord('6c24134d', component.options)
    } else {
      api.reload('6c24134d', component.options)
    }
    module.hot.accept("./DiscountAdvantagesPopin.vue?vue&type=template&id=6c24134d&scoped=true&", function () {
      api.rerender('6c24134d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/advantages/DiscountAdvantagesPopin.vue"
export default component.exports